import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconButtonModule } from '../../icon-buttons/icon-button.module';
import { FormButtonTooltipComponent } from './form-button-tooltip.component';
import { TooltipContentComponent } from './tooltip-content.component';
import { TooltipIconDirective } from './tooltip-icon.directive';
import { TooltipDirective } from './tooltip.directive';

/**
 * PRIVATE!
 *
 * Use {@link FormsModule}.
 */
@NgModule({
    imports: [
        CommonModule,
        IconButtonModule,
    ],
    declarations: [
        FormButtonTooltipComponent,
        TooltipIconDirective,
        TooltipDirective,
        TooltipContentComponent
    ],
    exports: [
        FormButtonTooltipComponent,
        TooltipDirective,
        TooltipIconDirective
    ]
})
export class FormTooltipModule {
}
